import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  // clsx combines class strings/conditionals into one string
  // twMerge deduplicates Tailwind conflicts
  return twMerge(clsx(inputs));
}